module.exports = __webpack_public_path__ + "static/media/google-icon.45dff0ba.svg";